import { useRecoilState } from 'recoil';
import { confetti } from '../atoms/shared';

const useConfetti = () => {
  const [showConfetti, setShowConfetti] = useRecoilState(confetti);

  return { isFire: showConfetti, setFire: setShowConfetti };
};

export default useConfetti;
